/* eslint-disable complexity */
// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import { getIconPath, removeSessionStorage } from '@tcp/core/src/utils';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor';
import Image from '@tcp/core/src/components/common/atoms/Image';
import ErrorMessage from '@tcp/core/src/components/features/CnC/common/molecules/ErrorMessage';
import {
  getDynamicLabelValues,
  renderLabel,
  getLabelFromCopyOrFromTranslation,
} from '@tcp/core/src/utils/labels/labelUtilty';
import {
  GLOBAL_ACTIONS_LABELS,
  GlobalActionsLabels,
} from '@tcp/core/src/utils/labels/globalActions.labels';
import {
  setContactFormValuesInSS,
  getContactFormValuesFromSS,
} from '@tcp/core/src/components/features/CnC/SinglePageCheckout/molecules/ContactForm/ContactForm.util';
import { CONTACT_FORM } from '@tcp/core/src/components/features/CnC/SinglePageCheckout/molecules/ContactForm/ContactForm.constant';
import withStyles from '../../../../../../common/hoc/withStyles';
import CreateAccounPage from '../../../organisms/CreateAccountPage';
import Styles from '../styles/CreateAccount.style';
import CreateAccountNewHeader from '../../../organisms/CreateAccountNewHeader/views/CreateAccountNewHeader.view';

class CreateAccount extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMessageVisible: true,
    };
  }

  static propTypes = {
    className: PropTypes.string,
    createAccountAction: PropTypes.func.isRequired,
    isIAgreeChecked: PropTypes.bool.isRequired,
    hideShowPwd: PropTypes.bool.isRequired,
    confirmHideShowPwd: PropTypes.bool.isRequired,
    error: PropTypes.shape({}).isRequired,
    onAlreadyHaveAnAccountClick: PropTypes.func.isRequired,
    onRequestClose: PropTypes.func.isRequired,
    openModal: PropTypes.func.isRequired,
    isUserLoggedIn: PropTypes.bool.isRequired,
    userplccCardNumber: PropTypes.string.isRequired,
    userplccCardId: PropTypes.string.isRequired,
    isLoading: PropTypes.bool.isRequired,
    isResetPassCodeValidationEnabled: PropTypes.bool.isRequired,
    closeOverlay: PropTypes.func.isRequired,
    existingUserInformation: PropTypes.shape({}),
    fullPageView: PropTypes.bool,
    formSubmissionTriggered: PropTypes.bool,
    showSkeleton: PropTypes.bool,
  };

  static defaultProps = {
    className: '',
    existingUserInformation: {},
    fullPageView: false,
    formSubmissionTriggered: false,
    showSkeleton: false,
  };

  showForgotPasswordForm = () => {
    const { openModal } = this.props;
    openModal({
      component: 'login',
      componentProps: {
        currentForm: 'forgotPassword',
      },
    });
  };

  clickBackButton = (e) => {
    const {
      isOTpScreenEnabled,
      showOtpScreen,
      resetLoginState,
      isShowOTPInputScreen,
      saveExistingUserResponse,
    } = this.props;

    const contactFormValuesFromSS = getContactFormValuesFromSS();

    const updatedContactFormValues = {
      ...contactFormValuesFromSS,
      isCreateAccountOtpScreen: false,
    };

    e.preventDefault();

    if (!isShowOTPInputScreen && isOTpScreenEnabled) {
      setContactFormValuesInSS();
      saveExistingUserResponse('');
      removeSessionStorage(CONTACT_FORM);
      window.history.back();
    } else if (isShowOTPInputScreen && isOTpScreenEnabled) {
      showOtpScreen();
      resetLoginState();
      setContactFormValuesInSS({ ...updatedContactFormValues });
      this.setState({ errorMessageVisible: true });
    } else if (window.history && window.history.back && !isShowOTPInputScreen) {
      window.history.back();
    }
  };

  showBackButton = () => {
    const {
      isNewRegisteredFlow,
      isShowOTPInputScreen,
      isOTpScreenEnabled,
      loginFlowUXEnhancementEnabled,
    } = this.props;
    const lefttarrow = getIconPath('toggle-left-arrow');
    if (
      isNewRegisteredFlow ||
      loginFlowUXEnhancementEnabled ||
      (isShowOTPInputScreen && isOTpScreenEnabled)
    ) {
      return (
        <>
          <div className="back-button elem-mt-MED elem-ml-MED">
            <Image src={lefttarrow} onClick={this.clickBackButton} />
            <Anchor
              underline
              noLink
              fontFamily="secondary"
              fontSizeVariation="large"
              tag="span"
              fontSize="fs14"
              className="elem-ml-MED"
              onClick={this.clickBackButton}
            >
              {renderLabel(
                getLabelFromCopyOrFromTranslation(
                  `${GLOBAL_ACTIONS_LABELS}.lbl_back`,
                  GlobalActionsLabels
                ),
                'lbl_back'
              )}
            </Anchor>
          </div>
        </>
      );
    }
    return null;
  };

  handleClose = () => {
    this.setState({ errorMessageVisible: false });
  };

  render() {
    const {
      className,
      createAccountAction,
      isIAgreeChecked,
      hideShowPwd,
      confirmHideShowPwd,
      error,
      onAlreadyHaveAnAccountClick,
      onRequestClose,
      isUserLoggedIn,
      userplccCardNumber,
      userplccCardId,
      isLoading,
      closeOverlay,
      isResetPassCodeValidationEnabled,
      existingUserInformation,
      fullPageView,
      formSubmissionTriggered,
      showSkeleton,
      isNewRegisteredFlow,
      isSafari,
      isBonusPointsEventMessagingEnabled,
      isShowOTPInputScreen,
      isFromCheckout,
      routeForBagCheckout,
      saveExistingUserResponse,
      isOTpScreenEnabled,
      userEmail,
      onSubmit,
      existingUserResponse,
      loginErrorMessage,
      resetLoginState,
      otpToken,
      onGenerateOTP,
      setIsFromCreateAccount,
      isLoginLoading,
      setLoader,
      sessionStorageUserInfo,
      showVerificationError,
      showRecaptcha,
      setOnSubmitLoader,
      setOffSubmitLoader,
      isInternationalPhoneNumberEnabled,
      dispatchFormFieldChange,
      loginFlowUXEnhancementEnabled,
      isUpdatedCanadaTermsAndConditions,
      isHideLoginLoader,
    } = this.props;

    const { vstatus } = existingUserResponse || {};
    const { vstatus: verificationStatus, token } = sessionStorageUserInfo || {};
    const { errorMessageVisible } = this.state;
    const showCreateAccOtpScreen =
      (vstatus !== undefined && !vstatus) ||
      (verificationStatus !== undefined && !verificationStatus) ||
      showVerificationError;
    let emailIsNewRegisteredFlow = '';
    if (isNewRegisteredFlow) {
      const contactFormValuesFromSS = getContactFormValuesFromSS();
      emailIsNewRegisteredFlow = contactFormValuesFromSS.emailAddress;
    }
    return (
      <div className={className}>
        {showCreateAccOtpScreen &&
          isOTpScreenEnabled &&
          isShowOTPInputScreen &&
          errorMessageVisible && (
            <>
              <ErrorMessage
                isCloseable
                error={getDynamicLabelValues('dynamic.account_d.lbl_email_verification_error')}
                spc
                fromLoginFlow
                handleClose={this.handleClose}
              />
            </>
          )}
        {this.showBackButton()}
        {loginFlowUXEnhancementEnabled && !isShowOTPInputScreen && (
          <CreateAccountNewHeader
            emailIsNewRegisteredFlow={emailIsNewRegisteredFlow}
            onAlreadyHaveAnAccountClick={onAlreadyHaveAnAccountClick}
            saveExistingUserResponse={saveExistingUserResponse}
            isFromCheckout={isFromCheckout}
          />
        )}

        <CreateAccounPage
          className={className}
          createAccountAction={createAccountAction}
          isIAgreeChecked={isIAgreeChecked}
          hideShowPwd={hideShowPwd}
          confirmHideShowPwd={confirmHideShowPwd}
          error={error}
          onAlreadyHaveAnAccountClick={onAlreadyHaveAnAccountClick}
          onRequestClose={onRequestClose}
          showForgotPasswordForm={this.showForgotPasswordForm}
          isUserLoggedIn={isUserLoggedIn}
          userplccCardNumber={userplccCardNumber}
          userplccCardId={userplccCardId}
          isLoading={isLoading}
          closeOverlay={closeOverlay}
          isResetPassCodeValidationEnabled={isResetPassCodeValidationEnabled}
          existingUserInformation={existingUserInformation}
          fullPageView={fullPageView}
          formSubmissionTriggered={formSubmissionTriggered}
          showSkeleton={showSkeleton}
          isNewRegisteredFlow={isNewRegisteredFlow}
          isSafari={isSafari}
          isBonusPointsEventMessagingEnabled={isBonusPointsEventMessagingEnabled}
          isShowOTPInputScreen={isShowOTPInputScreen}
          isFromCheckout={isFromCheckout}
          routeForBagCheckout={routeForBagCheckout}
          saveExistingUserResponse={saveExistingUserResponse}
          isOTpScreenEnabled={isOTpScreenEnabled}
          userEmail={userEmail}
          onSubmit={onSubmit}
          existingUserResponse={existingUserResponse}
          loginErrorMessage={loginErrorMessage}
          resetLoginState={resetLoginState}
          otpToken={otpToken || token}
          onGenerateOTP={onGenerateOTP}
          setIsFromCreateAccount={setIsFromCreateAccount}
          isLoginLoading={isLoginLoading}
          isHideLoginLoader={isHideLoginLoader}
          setLoader={setLoader}
          showNewOtpScreen={
            isShowOTPInputScreen &&
            isOTpScreenEnabled &&
            !error &&
            existingUserResponse?.emailAddress
          }
          showRecaptcha={showRecaptcha}
          setOnSubmitLoader={setOnSubmitLoader}
          setOffSubmitLoader={setOffSubmitLoader}
          isInternationalPhoneNumberEnabled={isInternationalPhoneNumberEnabled}
          dispatchFormFieldChange={dispatchFormFieldChange}
          loginFlowUXEnhancementEnabled={loginFlowUXEnhancementEnabled}
          emailIsNewRegisteredFlow={emailIsNewRegisteredFlow}
          isUpdatedCanadaTermsAndConditions={isUpdatedCanadaTermsAndConditions}
        />
      </div>
    );
  }
}

export default withStyles(CreateAccount, Styles);
export { CreateAccount as CreateAccountVanilla };
